var map = {
	"./de-DE/txt_vote-share.png": "2a87",
	"./en-GB/txt_vote-share.png": "1121",
	"./en-US/txt_vote-share.png": "e43e",
	"./es-ES/txt_vote-share.png": "02bb",
	"./es-MX/txt_vote-share.png": "e3d2",
	"./fr-CA/txt_vote-share.png": "161a",
	"./fr-FR/txt_vote-share.png": "4dcb",
	"./it-IT/txt_vote-share.png": "db0f",
	"./ja-JP/txt_vote-share.png": "82e6",
	"./pt-BR/txt_vote-share.png": "2bf5",
	"./zh-TW/txt_vote-share.png": "89eb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c815";